import { Component } from '@angular/core';
import { text } from 'stream/consumers';

@Component({
  selector: 'tea-shop-fe-home-featured',
  // standalone: true,
  // imports: [],
  templateUrl: './home-featured.component.html',
  styleUrl: './home-featured.component.css',
  standalone: false
})
export class HomeFeaturedComponent {

  // List of featured teas with image and link
  teas = [
    {
      name: 'White Tea',
      image: '/assets/home-feature/1-white-tea-home-page.jpg',
      link: '/tea-type/white-tea',
      bgcolor: 'rgba(213, 204, 195, 0.86)',
      // textcolor: '#b36935',
      textcolor: '#8B4B1D',
    },
    {
      name: 'Green Tea',
      image: '/assets/home-feature/2-green-tea-home-page.jpg',
      link: '/tea-type/green-tea',
      bgcolor: 'rgba(98, 106, 46, 0.86)',
      textcolor: '#bbd952',
    },
    {
      name: 'Oolong Tea',
      image: '/assets/home-feature/3-oolong-tea-home-page.jpg',
      link: '/tea-type/oolong',
      bgcolor: 'rgba(115, 45, 31, 0.86)',
      textcolor: '#ecbd43',
    },
    {
      name: 'Black Tea',
      image: '/assets/home-feature/4-black-tea-home-page.jpg',
      link: '/tea-type/black-tea',
      bgcolor: 'rgba(3, 3, 3, 0.86)',
      textcolor: '#c17211',
    },
    {
      name: 'High Mountain Tea',
      image: '/assets/home-feature/5-high-mt-tea-home-page.jpg',
      link: '/tea-type/high-mountain-tea',
      bgcolor: 'rgba(63, 81, 108, 0.86)',
      textcolor: '#a5b7e8',
    },
    {
      name: 'Herbal Tea',
      image: '/assets/home-feature/6-herbal-tea-home-page.jpg',
      link: '/tea-type/herbal-tea',
      bgcolor: 'rgba(118, 163, 140, 0.86)',
      textcolor: '#88073c',
    },
    {
      name: 'Matcha',
      image: '/assets/home-feature/7-matcha-home-page.jpg',
      link: '/tea-type/matcha',
      bgcolor: 'rgba(52, 83, 42, 0.86)',
      textcolor: '#cdce54',
    }
  ];

}
